import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontWeights } from '../../../types/common/types';
export const templateIntegrationInformation = document.createElement('template');

templateIntegrationInformation.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper" id="integration_information_wrapper">
  <gz-title id="information-title" class="mb-2" fontSize="16" fontWeight="${FontWeights.SEMIBOLD}"></gz-title>
  <div id="integration_information-checklist"></div>
</div>
`;
